module.exports = __webpack_public_path__ + "static/media/zone6-electrical.cc345047.png";